
// Init
var biro_search_desktop;
var biro_search_desktop_toggle;
var biro_search_desktop_form;

jQuery( function ( $ ) {

	// Init
	biro_search_desktop = $( '#header-search-desktop' );
	biro_search_desktop_toggle = $( '#header-search-toggle-desktop' );
	biro_search_desktop_form = $( '#header-search-form-desktop' );

	// Open / close form
	biro_search_desktop_toggle.on( 'click focus', function( e ) {

		// Init
		const $el = $( this );
		var search_width;

		if ( biro_search_desktop.attr( 'aria-expanded' ) === 'false' ) {

			if ( biro_vw_lg ) {
				search_width = 610;
			} else {
				search_width = 650;
			}

			biro_search_desktop_form.animate(
				{ width: search_width },
				200,
				function() {
					biro_search_desktop.attr( 'aria-expanded', 'true' ).find( '.header-search-text' ).focus();
				}
			);

		} else {

			biro_search_desktop_form.animate(
				{ width: 0 },
				200,
				function() {
					biro_search_desktop.attr( 'aria-expanded', 'false' ).find( '.header-search-text' ).blur();
				}
			);

		}

	});

});
